module.exports = __webpack_public_path__ + "static/media/test-clock.320e56cf.svg";